import React, {useEffect, useState} from 'react';
import styles from './resetpass-content.module.scss';
import {Row} from "react-bootstrap";
import {useNavigate} from "react-router-dom";
import PhoneNumber from "@/components/auth/resetpass/phonenumber";
import EnterCode from "@/components/auth/resetpass/enter-code";
import ChangePassword from "@/components/auth/resetpass/change-password";
import AuthService from "@/services/auth-service";
import {useDispatch} from "react-redux";

const ResetPassContent: React.FC<any> = () => {
    const states = {
        PHONE_NUMBER: 1,
        ENTER_CODE: 2,
        CHANGE_PASSWORD: 3
    }

    const [countDown, setCountDown] = useState<number | null>(null);
    const [phone_number, setPhoneNumber] = useState<string>('');
    const [code, setCode] = useState<string>('');
    const [currentState, setCurrentState] = useState<number>(states.PHONE_NUMBER);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const onPhoneNumberSuccess = (phone_number: string) => {
        setCurrentState(states.ENTER_CODE);
        setPhoneNumber(phone_number);
    };

    const onEnterCodeSuccess = (code: string) => {
        setCurrentState(states.CHANGE_PASSWORD);
        setCode(code);
    };

    useEffect(() => {
        if(phone_number) {
            AuthService.requestSMSCode(phone_number)(dispatch).then((count_down) => {
                setCountDown(count_down);
            });
        }
    }, [phone_number]);

    useEffect(() => {
        setTimeout(() => setCountDown(Math.max((countDown || 90) - 1, 0)), 1000);
    }, [countDown]);

    const onPasswordChangeSuccess = () => {
        return navigate('/login');
    };

    return (
        <div className={styles.resetpass}>
            <Row>
                <div className="col-lg-6 d-none d-lg-block">
                    <img src="/images/samples/fingerprint.png" alt="فراموشی رمز" />
                </div>
                <div className="col-lg-6 col-md-8 m-auto">
                    <div className={styles.form}>
                        <div className={styles.title}>
                            <h3>فراموشی رمز</h3>
                        </div>
                        {currentState == states.PHONE_NUMBER ? (
                            <PhoneNumber phone_number={phone_number} onSuccess={onPhoneNumberSuccess} />
                        ) : ''}
                        {currentState == states.ENTER_CODE ? (
                            <EnterCode countDown={countDown} phone_number={phone_number} onSuccess={onEnterCodeSuccess} goBack={() => setCurrentState(cs => cs - 1)} />
                        ) : ''}
                        {currentState == states.CHANGE_PASSWORD ? (
                            <ChangePassword phone_number={phone_number} code={code} onSuccess={onPasswordChangeSuccess} />
                        ) : ''}
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default ResetPassContent;
